import z from "zod";

export const paymentLinkStatusSchema = z.enum([
  'pending',
  'sent',
  'paid',
  'failed',
  'expired',
  'viewed'
]);

export type PaymentLinkStatus = z.infer<typeof paymentLinkStatusSchema>;